import React from 'react';
import axios from 'axios';
import { UserContext } from '../../Context/UserContext';
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
  Button,
  Text,
  Box,
  Flex,
  Divider,
  useColorModeValue,
  Image,
  Avatar,
  Center,
  Icon,
  useDisclosure,
  Collapse,
  Spinner,
  Badge,
  Stack,
  IconButton,
} from '@chakra-ui/react';
import { FiCamera, FiLogOut, FiUpload } from 'react-icons/fi';
import { API_URL } from '../../api';

const GRUPOS = {
  1: { label: 'ADMINISTRADOR', color: 'red' },
  2: { label: 'REVENDA', color: 'purple' },
  3: { label: 'SUPORTE', color: 'blue' },
  4: { label: 'DESENVOLVIMENTO', color: 'green' },
  5: { label: 'FINANCEIRO', color: 'orange' },
  6: { label: 'SUPORTE', color: 'blue' },
  7: { label: 'COMERCIAL', color: 'teal' },
};

export function PerfilPhoto() {
  const { Userlogout, dados } = React.useContext(UserContext);
  const [UserData] = React.useState(JSON.parse(window.localStorage.getItem('UserData')));
  const [image, setImage] = React.useState(null);
  const [imgUrl, setImgUrl] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const { isOpen, onToggle, onClose: onCollapseClose } = useDisclosure();

  const grupo = GRUPOS[UserData?.cod_grupo] || { label: 'USUÁRIO', color: 'gray' };
  const initials = UserData?.nome_usu?.substring(0, 2).toUpperCase() || '??';
  const photoUrl = `${API_URL}/user/${UserData?.cod_usu}/imgperfil`;

  // Tenta carregar foto; se falhar usa avatar com iniciais
  const [hasPhoto, setHasPhoto] = React.useState(false);
  React.useEffect(() => {
    if (UserData?.nome_img_perfil || UserData?.img_perfil_dados) {
      setHasPhoto(true);
      setImgUrl(`${photoUrl}?t=${Date.now()}`);
    }
  }, []);

  const uploadImage = async (e) => {
    e.preventDefault();
    if (!image) return;
    setLoading(true);
    const formData = new FormData();
    formData.append('imgperfil', image);
    try {
      await axios.post(photoUrl, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setImgUrl(`${photoUrl}?t=${Date.now()}`);
      setHasPhoto(true);
      setImage(null);
      onCollapseClose();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const bgPopover = useColorModeValue('white', 'gray.800');
  const textColor = useColorModeValue('gray.700', 'gray.100');
  const subColor = useColorModeValue('gray.500', 'gray.400');

  return (
    <Popover placement="bottom-end" closeOnBlur>
      <PopoverTrigger>
        {/* Botão premium de perfil */}
        <Box
          as="button"
          position="relative"
          borderRadius="full"
          w="36px"
          h="36px"
          overflow="hidden"
          border="2px solid"
          borderColor="brand.400"
          boxShadow="0 0 0 3px rgba(214,158,46,0.25)"
          transition="all 0.2s"
          _hover={{ boxShadow: '0 0 0 4px rgba(214,158,46,0.45)', transform: 'scale(1.05)' }}
          cursor="pointer"
        >
          {hasPhoto ? (
            <Image
              src={imgUrl}
              w="100%"
              h="100%"
              objectFit="cover"
              onError={() => setHasPhoto(false)}
            />
          ) : (
            <Flex
              w="100%"
              h="100%"
              align="center"
              justify="center"
              bg="brand.500"
              color="white"
              fontSize="13px"
              fontWeight="800"
            >
              {initials}
            </Flex>
          )}
        </Box>
      </PopoverTrigger>

      <PopoverContent
        borderRadius="2xl"
        boxShadow="2xl"
        border="none"
        bg={bgPopover}
        w="260px"
        overflow="hidden"
      >
        <PopoverArrow bg={bgPopover} />
        <PopoverBody p={0}>
          {/* Header com foto grande */}
          <Box
            bgGradient="linear(to-br, brand.500, brand.700)"
            p={5}
            pb={8}
            position="relative"
          >
            <Center>
              <Box
                w="80px"
                h="80px"
                borderRadius="full"
                overflow="hidden"
                border="3px solid white"
                boxShadow="lg"
              >
                {hasPhoto ? (
                  <Image
                    src={imgUrl}
                    w="100%"
                    h="100%"
                    objectFit="cover"
                    onError={() => setHasPhoto(false)}
                  />
                ) : (
                  <Flex
                    w="100%"
                    h="100%"
                    align="center"
                    justify="center"
                    bg="brand.600"
                    color="white"
                    fontSize="28px"
                    fontWeight="800"
                  >
                    {initials}
                  </Flex>
                )}
              </Box>
            </Center>
          </Box>

          {/* Info do usuário */}
          <Stack spacing={1} px={4} pt={3} pb={2} mt={-2}>
            <Text fontWeight="800" fontSize="sm" color={textColor} textAlign="center">
              {UserData?.nome_usu}
            </Text>
            <Center>
              <Badge colorScheme={grupo.color} borderRadius="full" px={3} fontSize="10px">
                {grupo.label}
              </Badge>
            </Center>
          </Stack>

          <Divider my={2} />

          {/* Ações */}
          <Stack spacing={2} px={4} pb={4}>
            <Button
              size="sm"
              leftIcon={<FiCamera />}
              variant="outline"
              colorScheme="brand"
              borderRadius="full"
              onClick={onToggle}
              w="full"
            >
              Alterar Foto
            </Button>

            <Collapse in={isOpen} animateOpacity>
              <Box pt={2}>
                {loading ? (
                  <Flex justify="center" py={3}>
                    <Spinner color="brand.500" size="md" thickness="3px" />
                  </Flex>
                ) : (
                  <form onSubmit={uploadImage}>
                    <Stack spacing={2}>
                      {/* Input nativo escondido */}
                      <input
                        id="perfil-file-input"
                        type="file"
                        accept="image/*"
                        onChange={(e) => setImage(e.target.files[0])}
                        style={{ display: 'none' }}
                      />
                      {/* Botão estilizado que abre o seletor */}
                      <Button
                        size="sm"
                        leftIcon={<FiCamera />}
                        variant="outline"
                        colorScheme="gray"
                        borderRadius="full"
                        w="full"
                        onClick={() => document.getElementById('perfil-file-input').click()}
                      >
                        {image ? image.name.substring(0, 20) + (image.name.length > 20 ? '…' : '') : 'Escolher imagem'}
                      </Button>
                      <Button
                        size="sm"
                        leftIcon={<FiUpload />}
                        colorScheme="green"
                        borderRadius="full"
                        type="submit"
                        isDisabled={!image}
                        w="full"
                      >
                        Enviar Foto
                      </Button>
                    </Stack>
                  </form>
                )}
              </Box>
            </Collapse>

            <Button
              size="sm"
              leftIcon={<FiLogOut />}
              colorScheme="red"
              variant="ghost"
              borderRadius="full"
              onClick={Userlogout}
              w="full"
            >
              Deslogar
            </Button>
          </Stack>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
}

export default PerfilPhoto;